import { Link, useNavigate } from 'react-router-dom';

import { ROUTES } from '../Routes';
import { useState } from 'react';

const LoginPage = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleLogin = (e) => {
    e.preventDefault();
    setError('');

    const existingUsers = JSON.parse(localStorage.getItem('users')) || [];

    const user = existingUsers.find(
      (u) => u.email === formData.email && u.password === formData.password
    );

    if (user) {
      const { password, ...userWithoutPassword } = user;
      localStorage.setItem('currentUser', JSON.stringify(userWithoutPassword));

      alert(`Welcome back, ${user.name}!`);
      navigate('/');
    } else {
      setError('Invalid email or password.');
    }
  };

  return (
    <main className="main auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <h1 className="auth-title">Welcome Back</h1>
          <p className="auth-subtitle">Sign in to continue your gaming session</p>

          {error && (
            <div className="error-box" style={{ color: '#ff4d4d', textAlign: 'center', marginBottom: '1rem' }}>
              {error}
            </div>
          )}

          <form id="loginForm" className="auth-form" onSubmit={handleLogin}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input 
                type="email" 
                id="email" 
                name="email" 
                placeholder="you@example.com" 
                value={formData.email}
                onChange={handleChange}
                required 
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input 
                type="password" 
                id="password" 
                name="password" 
                placeholder="Enter your password" 
                value={formData.password}
                onChange={handleChange}
                required 
              />
            </div>

            <button type="submit" className="submit-btn">Sign In</button>
          </form>

          <div className="auth-footer">
            <p>Don't have an account? <Link to={ROUTES.REGISTER}>Create one</Link></p>
          </div>
        </div>
      </div>
    </main>
  );
};

export default LoginPage;